<template>
<div>
<el-card body-style="padding: 0; width:100%">
  <div slot="header" class="clearfix">
    <span style="color: #409EFF">账户余额统计</span>
  </div>
 <div id="AccountCharts" :style="{textAlign:'center',width: '100%', height: '56rem', margin:'2%'}">
</div>
</el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {getTotalBalanceMoney} from "../../api/b2cbusiness/b2c_investmoney";
export default {
  name: "AccountResultChart",
  data(){
    return {
      tableData:[]
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      getTotalBalanceMoney().then(res=>{
        if (res.success){
          //this.tableData = res.data;
          for (let item in res.data){
            this.tableData.push({value:res.data[item].balanceMoney, name:res.data[item].roleName})
          }
          console.log(this.tableData)
          this.drawPie(this.tableData);
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    drawPie(result){
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("AccountCharts"));

      myChart.setOption({
        title: {
          text: '账户余额',
          subtext: new Date().toLocaleString(),
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
        },
        series: [
          {
            name: '账户余额',
            type: 'pie',
            radius: '50%',
            data: result,
            label: {
              normal: {
                show: true,
                formatter: '{b}: {c}({d}%)'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
